var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2.25C6.619,2.25 2.25,6.619 2.25,12C2.25,17.381 6.619,21.75 12,21.75C17.381,21.75 21.75,17.381 21.75,12C21.75,6.619 17.381,2.25 12,2.25ZM12,3.75C16.553,3.75 20.25,7.447 20.25,12C20.25,16.553 16.553,20.25 12,20.25C7.447,20.25 3.75,16.553 3.75,12C3.75,7.447 7.447,3.75 12,3.75ZM11,12.75L11.25,12.75C11.25,12.75 11.25,16 11.25,16C11.25,16.414 11.586,16.75 12,16.75L13,16.75C13.414,16.75 13.75,16.414 13.75,16C13.75,15.586 13.414,15.25 13,15.25L12.75,15.25C12.75,15.25 12.75,12 12.75,12C12.75,11.586 12.414,11.25 12,11.25L11,11.25C10.586,11.25 10.25,11.586 10.25,12C10.25,12.414 10.586,12.75 11,12.75ZM12.01,7.25C12.424,7.25 12.76,7.586 12.76,8C12.76,8.414 12.424,8.75 12.01,8.75C11.596,8.75 11.26,8.414 11.26,8C11.26,7.586 11.596,7.25 12.01,7.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.881a9f4c.svg";
export { ForwardRef as ReactComponent };